import React, { useState } from "react";
import axios from "axios";
import { FileCopyOutlined, Close, Check, Refresh } from "@material-ui/icons";
import Countdown from "./Countdown";
import { toast } from "react-toastify";
import { generateTraceId } from "../../../helpers";

export default function PixModal({
  setOpen,
  pixCode,
  pixQR,
  pixTimer,
  clientId,
  hideStatusCheck = false
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);

  const handlePaymentCheck = async () => {
    if (!clientId) {
      toast.error("ID do cliente não encontrado.");
      return;
    }
    setPaymentLoading(true);
    try {
      // Simulate an API call to check payment status
      const response = await axios.get(
        process.env.REACT_APP_JUSBILL_URL +
          `/charges/pix/transaction/${encodeURIComponent(clientId)}`,
        {
          headers: {
            "x-trace-id": generateTraceId()
          }
        }
      );
      const status = response.data?.status;
      if (status === "paid") {
        setPaymentStatus("paid");
        toast.success("Pagamento confirmado!");
      } else if (status === "waiting_payment" || status === "pending") {
        toast.info("Pagamento em processamento.");
      } else {
        toast.error("Pagamento não encontrado. Tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao verificar pagamento:", error);
      toast.error("Erro ao verificar pagamento. Tente novamente.");
    } finally {
      setPaymentLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "32px",
          maxHeight: "100vh",
          minWidth: "320px",
          maxWidth: "680px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
          textAlign: "left",
          overflowY: "auto"
        }}
      >
        <div className="d-flex flex-row gap-8" style={{ gap: 8 }}>
          <div className="d-flex flex-column">
            <h2 style={{ fontSize: 20, marginBottom: 0 }}>Pagar com Pix</h2>
            <p style={{ fontSize: 14, marginTop: 8 }}>
              Para completar o pagamento via pix, envie o código para o cliente,
              assim ele poderá realizar o pagamento e continuar usando a
              plataforma.
            </p>
          </div>
          <button
            className="btn btn-outline-secondary border-0 rounded-circle align-self-start"
            style={{
              marginTop: "-8px",
              marginRight: "-8px",
              padding: "8px 8px"
            }}
            onClick={() => setOpen(false)}
          >
            <Close />
          </button>
        </div>
        <div
          className="d-flex flex-column justify-content-center"
          style={{ marginTop: 12, gap: 8 }}
        >
          <b style={{ fontSize: 14 }}>Copia e Cola</b>
          {isLoading ? (
            <span
              className="spinner-border align-self-center"
              role="status"
              aria-hidden="true"
              style={{ height: "18px", width: "18px" }}
            ></span>
          ) : (
            <textarea
              id="pixCode"
              value={isLoading ? "" : pixCode}
              rows={1}
              style={{
                width: "100%",
                backgroundColor: "#FAFBFF",
                borderRadius: 5,
                border: "1px solid #CAC9CF",
                padding: 10,
                fontSize: 14,
                resize: "none"
              }}
              onFocus={e => e.target.select()}
              readOnly
            />
          )}
          <div
            className="d-flex flex-column justify-content-center align-items-center text-center"
            style={{
              marginTop: 24,
              padding: "24px 40px",
              gap: 8,
              border: "1px solid #CAC9CF",
              borderRadius: 8
            }}
          >
            <b style={{ fontSize: 14 }}>Pagar com Pix</b>
            <p style={{ fontSize: 13 }}>
              Copie o código Pix acima e cole no app do seu banco. Seu pagamento
              será aprovado em alguns instantes.
            </p>
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center text-center"
                style={{ width: "160px", height: "160px" }}
              >
                <span
                  className="spinner-border"
                  role="status"
                  aria-hidden="true"
                  style={{ marginTop: 24 }}
                ></span>
              </div>
            ) : (
              <img
                src={pixQR}
                loading="eager"
                alt="Código Pix"
                style={{
                  width: "160px",
                  height: "160px",
                  marginTop: 24,
                  alignItems: "center"
                }}
              />
            )}
            <button
              className="btn btn-outline-primary"
              style={{ marginTop: 24 }}
              onClick={() =>
                navigator.clipboard
                  .writeText(pixCode)
                  .then(() => toast.success("Código copiado com sucesso!"))
                  .catch(() =>
                    toast.error(
                      "Não foi possível copiar o código. Copie manualmente."
                    )
                  )
              }
              disabled={isLoading}
            >
              <FileCopyOutlined /> Copiar Código
            </button>
          </div>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ marginTop: 24, fontSize: 14 }}
          >
            <p className="mb-0">Pix disponível por</p>
            <Countdown
              seconds={pixTimer}
              secondsStyle={{ fontWeight: "bold", fontSize: 14 }}
            />
          </div>
          {!hideStatusCheck && (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ marginTop: 24, fontSize: 14 }}
          >
            <p className="mb-0">Status do pagamento</p>
            {paymentStatus === "paid" ? (
              <div
                className="btn btn-outline-primary hover-none"
                style={{ cursor: "auto", minHeight: "39px" }}
                disabled
              >
                <Check style={{ marginRight: "4px" }} />
                <b>Pagamento Confirmado</b>
              </div>
            ) : (
              <button
                className="btn btn-outline-primary"
                style={{ minWidth: "108px" }}
                onClick={() => handlePaymentCheck()}
                disabled={isLoading || paymentLoading}
              >
                {paymentLoading ? (
                  <span
                    className="spinner-border align-self-center"
                    role="status"
                    aria-hidden="true"
                    style={{ height: "18px", width: "18px" }}
                  ></span>
                ) : (
                  <>
                    <Refresh /> Verificar
                  </>
                )}
              </button>
            )}
          </div>
          )}
        </div>
      </div>
    </div>
  );
}
